/* global module, $, Modernizr, _, Tracker */

var Typeahead = function ($, Modernizr, _, Tracker) {

    Modernizr.addTest('pointerevents', function(){
        "use strict";
        var element = document.createElement('x');
        element.style.cssText = 'pointer-events:auto';
        return element.style.pointerEvents === 'auto';
    });

    $(function() {
        "use strict";

        $('.typeahead').each(function () {
            var suggestTemplate = '<button type="button" class="typeahead__suggest <%= additionalClasses %>" data-value="<%= value %>"><%= text %></button>';

            var $root  = $(this);
            var $input = $root.find('.typeahead__input');
            var $drop  = $root.find('.typeahead__drop');
            var $valueHolder = $root.find('.typeahead__value-holder');
            var valueKey = $root.data('typeahead-value-key');
            var clickEvent = Modernizr.touch ? 'touchend' : 'mousedown';

            $(document).on('focus.Typeahead', '.typeahead__input', function () {

                $root.addClass('typeahead_dropped');

                $input.on('keydown.TypeaheadSuggest', _.debounce(function () {

                    if ($root.data('$ajax')) {
                        $root.data('$ajax').abort();
                    }

                    if ($input.val()) {
                        $root.addClass('typeahead_loading');
                        var queryParamName = $root.data('typeahead-query-param-name') || 'q';
                        var additionalQueryParams = $root.data('typeahead-additional-query-params') || {};

                        var data = {};
                        data[queryParamName] = $input.val();
                        data = _.extend(data, additionalQueryParams);

                        var $ajax = $.ajax({
                            url: $root.data('typeaheadUrl'),
                            method:  $root.data('typeaheadMethod'),
                            dataType: 'json',
                            data: data
                        })
                            .always(function () {
                                        $root.data('$ajax', null);
                                        $root.removeClass('typeahead_loading');
                                    })
                            .done(function (data) {
                                      $drop.find('.typeahead__suggest').remove();
                                      $drop.append(
                                          _(data).map(function (suggest) {
                                              var newSuggest = _.clone(suggest);

                                              if (!newSuggest.additionalClasses) {
                                                  newSuggest.additionalClasses = '';
                                              }
                                              if (valueKey) {
                                                  newSuggest.text = newSuggest.value;
                                                  newSuggest.value = newSuggest[valueKey];
                                              }
                                              else {
                                                  newSuggest.text = newSuggest.value;
                                              }

                                              return _.template(suggestTemplate, newSuggest);
                                          })
                                      );
                                  });

                        $root.data('$ajax', $ajax);
                    }

                }, 400));

                $root.on(clickEvent + '.Typeahead', '.typeahead__suggest', function (event) {
                    event.preventDefault();
                    $input.val($(this).text());

                    if ($valueHolder.length > 0) {
                        var val = valueKey ? $(this).data('value') : $(this).text();
                        $valueHolder.val(val);
                    }

                    $input.blur();
                    $root.trigger('Typeahead::Change');
                });

                $input.one('blur.Typeahead', function () {
                    $input.off('change.Typeahead');
                    $input.off('keydown.Typeahead');
                    $root.off(clickEvent + '.TypeaheadSuggest');
                    $root.removeClass('typeahead_dropped');
                });
            });

            $root.on(clickEvent + '.TypeaheadReset', '.typeahead__reset', function (event) {
                event.preventDefault();
                $valueHolder.val('');
                $input.val('');
                $(this).blur();
            });
        });
    });
};

if (typeof module !== 'undefined') {
    module.exports = Typeahead;
}
else {
    Typeahead(window.$, window.Modernizr, window._, window.Tracker);
}